import { Paragraph } from '@eggplant/pattern-library'

const Access = () =>
  <Paragraph>
    Here is where you can manage users, and control the level of access they have to DAI.
  </Paragraph>

export default Access
